import type { GQL_ID } from '@@partner:types:graphql'
import type { ProductReviewInput } from '@@partner:graphql/mutation/catalog/updateProductReview'
import type { ProductReviewInfo } from '@@partner:types:app'

import { mergeLeft } from 'merge-left-utils'

export interface ProductReviewFormState {
  id?: GQL_ID
  product_id?: GQL_ID
  comment?: string
  status: number
}

export const PRODUCT_REVIEW_STATE: ProductReviewFormState = {
  id: undefined,
  product_id: undefined,
  comment: '',
  status: 0
}

export const makeProductReviewFormState = (
  productReview?: ProductReviewInfo
): ProductReviewFormState => {
  return mergeLeft<ProductReviewFormState>(PRODUCT_REVIEW_STATE, productReview)
}

export const mapStateToApiVariable = (
  state: ProductReviewFormState
): ProductReviewInput => ({
  id: state.id,
  product_id: state.product_id,
  comment: state.comment,
  status: Number(state.status)
})

export const mapApiDataToState = (
  data: ProductReviewInfo
): ProductReviewFormState => ({
  id: data.id,
  product_id: data.product_id,
  comment: data.comment,
  status: data.status
})
